import { Box, Typography } from '@mui/material';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface IProps {
  label: string;
  value: number | string;
  isEstimated?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  trendValue?: number;
  valueColor?: string;
  reverseTrend?: boolean;
  ctaLabel?: string;
  ctaLink?: string;
  minWidthContainer?: number | 'auto';
}

const StatisticLabelValueItem = ({
  label,
  value,
  isEstimated,
  onClick,
  isSelected,
  trendValue,
  valueColor,
  reverseTrend = false,
  ctaLabel = '',
  ctaLink = '',
  minWidthContainer = 100,
}: IProps) => {
  // Calcola il colore del trend una sola volta
  const getTrendColor = () => {
    if (!trendValue) return '';
    const isPositiveTrend = trendValue > 0;
    if (reverseTrend) {
      return isPositiveTrend ? 'rgba(239, 68, 68, 1)' : 'rgba(22, 163, 74, 1)';
    }
    return isPositiveTrend ? 'rgba(22, 163, 74, 1)' : 'rgba(239, 68, 68, 1)';
  };

  const trendColor = trendValue ? getTrendColor() : '';

  return (
    <Box
      sx={{
        bgcolor: '#FAFAFA',
        borderRadius: '16px',
        padding: 2,
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        boxShadow: isSelected ? '0px 0px 10px rgba(0, 0, 0, 0.6)' : 'none',
        border: '1px solid gainsboro',
        minWidth: minWidthContainer,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          bgcolor: (th) => th.palette.primary.main,
          borderRadius: '5px',
          px: 2,
          mb: 0.5,
        }}
      >
        <Typography sx={{ color: 'white', fontSize: '14px' }}>
          {isEstimated ? 'Stima' : 'Reale'}
        </Typography>
      </Box>
      <Typography fontSize={14} fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="h4" fontWeight="bold" sx={{ color: valueColor }}>
        {value}
      </Typography>

      {trendValue && trendValue !== 0 ? (
        <Box mt={1}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            {trendValue > 0 ? (
              <NorthEastIcon fontSize="small" sx={{ color: trendColor }} />
            ) : (
              <SouthEastIcon fontSize="small" sx={{ color: trendColor }} />
            )}
            <Typography
              sx={{
                color: trendColor,
                fontWeight: 'bold',
                ml: 0.5,
              }}
            >
              {Math.abs(trendValue)}%
            </Typography>
          </Box>
          <Typography sx={{ fontSize: 12 }}>vs periodo precedente</Typography>
        </Box>
      ) : null}
      {ctaLabel.length > 0 && ctaLink.length > 0 && (
        <Box mt={1}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          ></Box>
          <a
            href={ctaLink}
            style={{
              marginLeft: 8,
              fontSize: 11,
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexDirection: 'column',
              color: '#56565d',
            }}
          >
            <TrendingDownIcon fontSize="small" sx={{ color: trendColor }} />
            <span>{ctaLabel}</span>
          </a>
        </Box>
      )}
    </Box>
  );
};

export default StatisticLabelValueItem;
